import styled, { keyframes } from 'styled-components';

const skeleton = keyframes`
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const TableNewLoaderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 20px;
  overflow: hidden;
  background-color: #f2f2f2;
  border-radius: 8px;
  transform: translate(0);

  &::before {
    content: '';
    display: block;
  }

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    display: block;
    background: linear-gradient(90deg, rgb(242, 242, 242), rgb(224, 224, 224), rgb(242, 242, 242));
    animation: ${skeleton} 5s linear 0.5s infinite;
  }
`;

export const TableNewLoaderBody = styled.span`
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
  clip-path: inset(50%);
`;
